<template>
  <div class="home">
    <h1 class="mt-16 text-h4 font-weight-bold text-center">
      {{ $city.name }}政府健檢預約平台
    </h1>
    <h2 class="my-4 text-h5 font-weight-bold text-center">
      您好，請先協助我們確認並完善您的個人資訊，以利進行資格查詢與預約。
    </h2>
    <div>
      <v-card class="mx-auto mt-16" max-width="400px">
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
              v-model="person.身分證字號"
              label="身分證字號"
              :rules="[(v) => !!v || `身分證字號為必填項目`]"
              outlined
              dense
              disabled
            ></v-text-field>
            <v-text-field
              v-model="person.出生年月日"
              label="生日"
              :rules="[
                (v) => !!v || `生日為必填項目`,
                (v) =>
                  /^\d{6}$/.test(v) ||
                  `出生年月日格式錯誤，民國生日 6 碼，例如 35 年 04 月 11 日，請輸入 350411`,
              ]"
              outlined
              dense
              disabled
            ></v-text-field>
            <v-text-field
              v-model="person.姓名"
              label="姓名（必填）"
              :rules="[(v) => !!v || `姓名為必填項目`]"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              v-model="person.電話"
              label="手機號碼（必填）"
              :rules="[
                (v) => !!v || `手機號碼為必填項目`,
                (v) =>
                  /^09\d{8}$/.test(v) ||
                  `手機號碼格式錯誤，僅接受手機門號共 10 碼`,
              ]"
              outlined
              persistent-hint
              hint="僅接受手機門號共 10 碼"
              dense
            ></v-text-field>
          </v-form>
          <v-btn @click="save" class="my-4" x-large block color="primary">
            確認儲存
          </v-btn>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "Personal",
  data: () => ({
    valid: false,
    person: null,
  }),
  async created() {
    this.person = { ...this.$store.state.person };
    if (/^9[0-9]{8}/.test(this.person.電話)) {
      this.person.電話 = 0 + this.person.電話;
    }
  },
  methods: {
    save() {
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        this.$store.commit("setState", { person: this.person });
        this.axios.post(`/updatePhone`, this.person);
        this.$router.push("/itemCheck");
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
